import React, { FC } from "react";
import { PiHighlighterFill as HighlighterIcon } from "react-icons/pi";
import { useMediaQuery } from "react-responsive";
import { Editor } from "@tiptap/react";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { ColorButton } from "./ToolbarButtons/ColorButton";
import { BLACK_BASE } from "./constants/colors";
import { Tooltip } from "../Tooltip";
import { Button } from "../Button";
import { ButtonVariants } from "../Button/types";

interface Props {
  editor: Editor;
  colors: string[];
}

export const HighlighterTooltip: FC<Props> = ({ editor, colors }) => {
  const isGLScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.GL,
  });

  const isActive = (color: string) => editor.isActive("highlight", { color });
  const getActiveHighlightColor = () => editor.getAttributes("highlight").color;

  const onClickColorButton = (color: string) => () => {
    editor.chain().focus().toggleHighlight({ color }).run();
  };
  return (
    <Tooltip
      position={isGLScreenBreakpoint ? "right" : "top"}
      content={
        <div className="flex items-center justify-start gap-2">
          {colors.map((color) => (
            <ColorButton
              key={color}
              color={color}
              isActive={isActive(color)}
              onClick={onClickColorButton(color)}
            />
          ))}
        </div>
      }
    >
      <Button
        type="button"
        variant={ButtonVariants.SECONDARY}
        className="!rounded-md !duration-100 !p-1"
      >
        <HighlighterIcon
          title="highlight color"
          className="w-5 h-5 transition-none"
          style={{ color: getActiveHighlightColor() || BLACK_BASE }}
        />
      </Button>
    </Tooltip>
  );
};
